import MultipleTicker from "./components/MultipleTicker";
import Footer from "./components/Footer";
import { useTemplateSetting } from "./hooks/useCompanySettings";
import { useEffect } from "react";
import MainContent from "./components/MainContent";
import { useSelector } from "react-redux";
import { colorBlindModeSelector } from "./store/slice/settings/selectors";
import { classNames } from "./utils";
import { TOOL_TEMPLATE } from "./constant/common";
import MainContextProvider from "./contexts/MainContext";

function App() {
  const template = useTemplateSetting();
  const colorBlindMore = useSelector(colorBlindModeSelector);
  useEffect(() => {
    const templateClass = `template-${template.toLocaleLowerCase()}`;
    document.body.classList.add(templateClass);
    document.body.setAttribute("dir", window.appSettings?.isRtl ? "rtl" : "ltr");
    return () => {
      document.body.classList.remove(templateClass);
      document.body.removeAttribute("dir");
    };
  }, [template, colorBlindMore]);
  return (
    <>
      <main
        className={classNames("main-app", {
          "color-blind-mode": colorBlindMore,
        })}
      >
        {template === TOOL_TEMPLATE.victor && <MultipleTicker />}
        <MainContextProvider>
          <MainContent />
        </MainContextProvider>
      </main>
      <Footer />
    </>
  );
}

export default App;
